import RouteNames from "@/entities/RouteNames";
import RouteWrapper from "@/components/common/RouteWrapper.vue";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import Roles from "@/entities/Roles";
import sidebarData from "@/data/sidebar";
const admin = sidebarData.find(
  (a) =>
    (a.role.includes(Roles.ADMIN) || a.role.includes(Roles.MANAGER)) &&
    a.slug === "/manage"
);
const contractor = sidebarData.find((a) => a.role.includes(Roles.CONTRACTOR));
const Invoice = () =>
  import("@/views/invoice/Invoice.vue").then((m) => m.default);
const SubmitInvoice = () =>
  import("@/views/invoice/SubmitInvoice.vue").then((m) => m.default);
const InvoiceDetail = () =>
  import("@/views/invoice/invoiceDetail/invoiceDetail.vue").then(
    (m) => m.default
  );

const getInvoicesRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/invoice",
    component: RouteWrapper,
    props: true,
    meta: {
      title: "Invoice",
      requiresAuth: true,
      roles: [Roles.CONTRACTOR, Roles.ADMIN],
      breadcrumb: {
        title: (user) =>
          user?.role === Roles.CONTRACTOR
            ? (contractor.title as string)
            : (admin.title as string),
        routeName: RouteNames.INVOICE,
        isStyled: true,
      },
    },
  },
]);

const getInvoicePrivatePageTabsRoutes: GetRelativeRoutes = getChildRoutes([
  //   {
  //     path: "",
  //     name: RouteNames.INVOICE,
  //     component: Invoice,
  //     meta: {
  //       title: "Invoice Details",

  //       roles: [Roles.CONTRACTOR, Roles.ADMIN],
  //       breadcrumb: {
  //         title: "Invoices",
  //         routeName: (user) => RouteNames.INVOICE,
  //         isStyled: true,
  //       },
  //     },
  //   },

  {
    path: "",
    name: RouteNames.INVOICE,
    component: Invoice,
    meta: {
      title: "Invoices",
      roles: [Roles.CONTRACTOR, Roles.ADMIN],
      breadcrumb: {
          title: "Invoices",
        //   routeName: (user) => RouteNames.INVOICE,
        isStyled: true,
      },
    },
  },

  {
    path: "submit-invoice",
    name: RouteNames.INVOICE_SUBMIT,
    component: SubmitInvoice,
    meta: {
      title: "Submit Invoice",
      roles: [Roles.CONTRACTOR, Roles.ADMIN],
      breadcrumb: {
        title: "Submit Invoice",
        routeName: (user) => RouteNames.INVOICE,
        isStyled: true,
      },
    },
  },
  {
    path: "edit/:id",
    name: RouteNames.INVOICE_EDIT,
    component: SubmitInvoice,
    meta: {
      title: "Submit Invoice",
      roles: [Roles.CONTRACTOR, Roles.ADMIN],
      breadcrumb: {
        title: "Submit Invoice",
        routeName: (user) => RouteNames.INVOICE_DETAIL,
        isStyled: true,
      },
    },
  },
  {
    path: ":id",
    name: RouteNames.INVOICE_DETAIL,
    component: InvoiceDetail,
    meta: {
      title: "View Invoice",
      roles: [Roles.CONTRACTOR, Roles.ADMIN],
      breadcrumb: {
        title: "View Invoice",
        routeName: (user) => RouteNames.INVOICE,
        isStyled: true,
      },
    },
  },

  //   {
  //     path: "submit-invoice",
  //     name: RouteNames.INVOICE_SUBMIT,
  //     component: SubmitInvoice,
  //     meta: {
  //       title: "Submit invoice",
  //       roles: [Roles.CONTRACTOR, Roles.ADMIN],
  //     },
  //   },
  //   {
  //     path: "edit/:id",
  //     name: RouteNames.INVOICE_EDIT,
  //     component: SubmitInvoice,
  //     meta: {
  //       title: "Submit invoice",
  //       roles: [Roles.CONTRACTOR, Roles.ADMIN],
  //     },
  //   },
  //   {
  //     path: ":id",
  //     name: RouteNames.INVOICE_DETAIL,
  //     component: InvoiceDetail,
  //     meta: {
  //       title: "Submit invoice",
  //       roles: [Roles.CONTRACTOR, Roles.ADMIN],
  //       breadcrumb: {
  //         title: "View Invoice",
  //         routeName: (user) => RouteNames.INVOICE,
  //         isStyled: true,
  //       },
  //     },
  //   },
]);
const getInvoicePrivatePageRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "",
    component: RouteWrapper,
    meta: {
      title: "Invoices",

      roles: [Roles.CONTRACTOR, Roles.ADMIN],
      breadcrumb: {
        title: "Invoices",
        routeName: (user) => RouteNames.INVOICE,
        isStyled: true,
      },
    },
  },
]);
const getInvoicePrivateSubmit: GetRelativeRoutes = getChildRoutes([]);

export {
  getInvoicesRoutes,
  getInvoicePrivatePageTabsRoutes,
  getInvoicePrivateSubmit,
  getInvoicePrivatePageRoutes,
};
